/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Enhanced list method with metadata
 */
export const CertificatesListQueryParams = zod.object({
  "car": zod.string().uuid().optional(),
  "date_issued": zod.string().date().optional(),
  "expiration_date": zod.string().date().optional(),
  "expires_after": zod.string().date().optional().describe('Filter certificates expiring after or on this date'),
  "expires_before": zod.string().date().optional().describe('Filter certificates expiring before or on this date'),
  "external_id": zod.string().optional(),
  "external_source": zod.string().optional(),
  "has_closed_violations": zod.boolean().optional().describe('Has Closed Violations'),
  "has_open_violations": zod.boolean().optional().describe('Has Open Violations'),
  "has_stale_violations": zod.boolean().optional().describe('Filter certificates that have violations with no updates in 2 weeks'),
  "inspection_status": zod.enum(['failed', 'passed', 'pending']).optional().describe('Inspection Status\n\n\* `passed` - Passed\n\* `failed` - Failed\n\* `pending` - Pending'),
  "jurisdiction": zod.string().optional().describe('Jurisdiction'),
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "next_violation_due_after": zod.string().date().optional().describe('Format: YYYY-MM-DD'),
  "next_violation_due_before": zod.string().date().optional().describe('Format: YYYY-MM-DD'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.'),
  "ordering": zod.array(zod.enum(['-expiration_date', 'expiration_date'])).optional().describe('Ordering\n\n\* `expiration_date` - Expiration date\n\* `-expiration_date` - Expiration date (descending)'),
  "portfolio_id": zod.array(zod.string().uuid()).optional().describe('Portfolio ID'),
  "property_id": zod.array(zod.string().uuid()).optional().describe('Property ID'),
  "region": zod.string().optional().describe('Region'),
  "search": zod.string().optional().describe('Search'),
  "stale_violations_count": zod.number().optional().describe('Filter by exact number of violations without updates in 2 weeks'),
  "status": zod.enum(['active', 'expired', 'expiring_soon']).optional().describe('Certificate Status\n\n\* `active` - Active\n\* `expired` - Expired\n\* `expiring_soon` - Expiring Soon'),
  "unit_name": zod.string().optional().describe('Unit\/Car Name')
})

export const certificatesListResponseResultsItemJurisdictionMax = 100;

export const certificatesListResponseResultsItemCustomTypeMax = 100;

export const certificatesListResponseResultsItemAttachmentsItemPageNumberMin = 0;
export const certificatesListResponseResultsItemAttachmentsItemPageNumberMax = 2147483647;



export const CertificatesListResponse = zod.object({
  "metadata": zod.object({
  "activeCertificates": zod.number(),
  "expiringCertificates": zod.number(),
  "expiredCertificates": zod.number(),
  "certificatesByJurisdiction": zod.record(zod.string(), zod.number()).describe('Count of certificates grouped by jurisdiction'),
  "certificatesWithViolations": zod.number().describe('Count of certificates for cars with open violations')
}).strict().describe('Serializer for certificate metadata used in list view header'),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesListResponseResultsItemJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "customType": zod.string().max(certificatesListResponseResultsItemCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected'),
  "car": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().nullable(),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "daysUntilExpiration": zod.number(),
  "status": zod.string(),
  "violationSummary": zod.record(zod.string(), zod.unknown()).describe('Get summary of violations for this certificate\'s car'),
  "inspectionStatus": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "downloadUrl": zod.string().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesListResponseResultsItemAttachmentsItemPageNumberMin).max(certificatesListResponseResultsItemAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "inspectionDetails": zod.record(zod.string(), zod.unknown()).nullable()
}).strict().describe('Serializer for list view - includes related data needed for table display')),
  "count": zod.number().optional().describe('Only present when `limit` is supplied.'),
  "next": zod.string().url().nullish().describe('Only present when `limit` is supplied.'),
  "previous": zod.string().url().nullish().describe('Only present when `limit` is supplied.')
}).strict().describe('The real response body of ``CertificateViewSet.list``.\n\n``many=False`` stops drf-spectacular from arraying this and re-wrapping it\nin the paginator (it does that for any GET action named ``list``), which\nwould nest the envelope inside a second, non-existent one. It\'s the narrow\nlever on purpose: overriding ``_is_list_view`` instead would also drop the\nCertificateFilter query params and rename the operation to\n``certificatesRetrieve``, colliding with the detail route.\n\nThe view builds its own envelope rather than returning the paginator\'s, so\ndrf-spectacular\'s inferred ``PaginatedCertificateList`` (which makes\n``count`` required and has no ``metadata``) never matched the wire. The\npaginator is LimitOffsetPagination with no ``PAGE_SIZE``, so\n``paginate_queryset`` returns None unless the caller passes ``limit`` — and\nonly then do ``count``\/``next``\/``previous`` appear alongside ``metadata``\nand ``results``.')

/**
 * ViewSet for managing certificates
 */
export const certificatesCreateBodyJurisdictionMax = 100;

export const certificatesCreateBodyCustomTypeMax = 100;



export const CertificatesCreateBody = zod.object({
  "carId": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesCreateBodyJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "attachmentId": zod.string().uuid().nullish(),
  "customType": zod.string().max(certificatesCreateBodyCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).describe('Request-body schema for certificate create\/update.\n\nSame writable fields as CertificateCreateUpdateSerializer minus the\nread-only `id`, which the shared component otherwise marked required on the\ngenerated request type and forced an `as unknown as` cast at the call site\n(AMP-569). Used only for schema generation via ``@extend_schema(request=...)``;\nruntime processing still goes through CertificateCreateUpdateSerializer.')

export const certificatesCreateResponseJurisdictionMax = 100;

export const certificatesCreateResponseCustomTypeMax = 100;



export const CertificatesCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesCreateResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "customType": zod.string().max(certificatesCreateResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).strict().describe('Serializer for creating\/updating certificates')

export const CertificatesAttachmentsListParams = zod.object({
  "certificatePk": zod.string().uuid()
})

export const certificatesAttachmentsListResponsePageNumberMin = 0;
export const certificatesAttachmentsListResponsePageNumberMax = 2147483647;



export const CertificatesAttachmentsListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsListResponsePageNumberMin).max(certificatesAttachmentsListResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')
export const CertificatesAttachmentsListResponse = zod.array(CertificatesAttachmentsListResponseItem)

export const CertificatesAttachmentsCreateParams = zod.object({
  "certificatePk": zod.string().uuid()
})

export const certificatesAttachmentsCreateBodyPageNumberMin = 0;
export const certificatesAttachmentsCreateBodyPageNumberMax = 2147483647;



export const CertificatesAttachmentsCreateBody = zod.object({
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsCreateBodyPageNumberMin).max(certificatesAttachmentsCreateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const certificatesAttachmentsCreateResponsePageNumberMin = 0;
export const certificatesAttachmentsCreateResponsePageNumberMax = 2147483647;



export const CertificatesAttachmentsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsCreateResponsePageNumberMin).max(certificatesAttachmentsCreateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const CertificatesAttachmentsRetrieveParams = zod.object({
  "certificatePk": zod.string().uuid(),
  "id": zod.string().uuid().describe('A UUID string identifying this certificate attachment.')
})

export const certificatesAttachmentsRetrieveResponsePageNumberMin = 0;
export const certificatesAttachmentsRetrieveResponsePageNumberMax = 2147483647;



export const CertificatesAttachmentsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsRetrieveResponsePageNumberMin).max(certificatesAttachmentsRetrieveResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const CertificatesAttachmentsUpdateParams = zod.object({
  "certificatePk": zod.string().uuid(),
  "id": zod.string().uuid().describe('A UUID string identifying this certificate attachment.')
})

export const certificatesAttachmentsUpdateBodyPageNumberMin = 0;
export const certificatesAttachmentsUpdateBodyPageNumberMax = 2147483647;



export const CertificatesAttachmentsUpdateBody = zod.object({
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsUpdateBodyPageNumberMin).max(certificatesAttachmentsUpdateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const certificatesAttachmentsUpdateResponsePageNumberMin = 0;
export const certificatesAttachmentsUpdateResponsePageNumberMax = 2147483647;



export const CertificatesAttachmentsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsUpdateResponsePageNumberMin).max(certificatesAttachmentsUpdateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const CertificatesAttachmentsPartialUpdateParams = zod.object({
  "certificatePk": zod.string().uuid(),
  "id": zod.string().uuid().describe('A UUID string identifying this certificate attachment.')
})

export const certificatesAttachmentsPartialUpdateBodyPageNumberMin = 0;
export const certificatesAttachmentsPartialUpdateBodyPageNumberMax = 2147483647;



export const CertificatesAttachmentsPartialUpdateBody = zod.object({
  "certificate": zod.string().uuid().optional(),
  "attachment": zod.string().uuid().optional(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsPartialUpdateBodyPageNumberMin).max(certificatesAttachmentsPartialUpdateBodyPageNumberMax).nullish()
}).describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const certificatesAttachmentsPartialUpdateResponsePageNumberMin = 0;
export const certificatesAttachmentsPartialUpdateResponsePageNumberMax = 2147483647;



export const CertificatesAttachmentsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "certificate": zod.string().uuid(),
  "attachment": zod.string().uuid(),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesAttachmentsPartialUpdateResponsePageNumberMin).max(certificatesAttachmentsPartialUpdateResponsePageNumberMax).nullish()
}).strict().describe('Rejects linking an attachment whose owner belongs to a different\norganization than the entity it is being attached to.\n\nPrevents cross-tenant attachment association (IDOR): even a user with\naccess to the parent entity must not be able to attach a document owned\nby another organization. Access is evaluated through customer accounts,\nthe source of truth for property access.')

export const CertificatesAttachmentsDestroyParams = zod.object({
  "certificatePk": zod.string().uuid(),
  "id": zod.string().uuid().describe('A UUID string identifying this certificate attachment.')
})

export const CertificatesAttachmentsDestroyResponse = zod.void()

/**
 * ViewSet for managing certificates
 */
export const CertificatesRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Certificate.')
})

export const certificatesRetrieveResponseJurisdictionMax = 100;

export const certificatesRetrieveResponseCustomTypeMax = 100;

export const certificatesRetrieveResponseAttachmentsItemPageNumberMin = 0;
export const certificatesRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;



export const CertificatesRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesRetrieveResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "customType": zod.string().max(certificatesRetrieveResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected'),
  "car": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().nullable(),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "daysUntilExpiration": zod.number(),
  "status": zod.string(),
  "violationSummary": zod.record(zod.string(), zod.unknown()).describe('Get summary of violations for this certificate\'s car'),
  "inspectionStatus": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "downloadUrl": zod.string().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesRetrieveResponseAttachmentsItemPageNumberMin).max(certificatesRetrieveResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "inspectionDetails": zod.record(zod.string(), zod.unknown()).nullable()
}).strict().describe('Serializer for list view - includes related data needed for table display')

/**
 * ViewSet for managing certificates
 */
export const CertificatesUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Certificate.')
})

export const certificatesUpdateBodyJurisdictionMax = 100;

export const certificatesUpdateBodyCustomTypeMax = 100;



export const CertificatesUpdateBody = zod.object({
  "carId": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesUpdateBodyJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "attachmentId": zod.string().uuid().nullish(),
  "customType": zod.string().max(certificatesUpdateBodyCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).describe('Request-body schema for certificate create\/update.\n\nSame writable fields as CertificateCreateUpdateSerializer minus the\nread-only `id`, which the shared component otherwise marked required on the\ngenerated request type and forced an `as unknown as` cast at the call site\n(AMP-569). Used only for schema generation via ``@extend_schema(request=...)``;\nruntime processing still goes through CertificateCreateUpdateSerializer.')

export const certificatesUpdateResponseJurisdictionMax = 100;

export const certificatesUpdateResponseCustomTypeMax = 100;



export const CertificatesUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesUpdateResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "customType": zod.string().max(certificatesUpdateResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).strict().describe('Serializer for creating\/updating certificates')

/**
 * ViewSet for managing certificates
 */
export const CertificatesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Certificate.')
})

export const certificatesPartialUpdateBodyJurisdictionMax = 100;

export const certificatesPartialUpdateBodyCustomTypeMax = 100;



export const CertificatesPartialUpdateBody = zod.object({
  "carId": zod.string().uuid().optional(),
  "jurisdiction": zod.string().max(certificatesPartialUpdateBodyJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().optional().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().optional().describe('The date when the certificate expires'),
  "attachmentId": zod.string().uuid().nullish(),
  "customType": zod.string().max(certificatesPartialUpdateBodyCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).describe('Request-body schema for certificate create\/update.\n\nSame writable fields as CertificateCreateUpdateSerializer minus the\nread-only `id`, which the shared component otherwise marked required on the\ngenerated request type and forced an `as unknown as` cast at the call site\n(AMP-569). Used only for schema generation via ``@extend_schema(request=...)``;\nruntime processing still goes through CertificateCreateUpdateSerializer.')

export const certificatesPartialUpdateResponseJurisdictionMax = 100;

export const certificatesPartialUpdateResponseCustomTypeMax = 100;



export const CertificatesPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesPartialUpdateResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "customType": zod.string().max(certificatesPartialUpdateResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected')
}).strict().describe('Serializer for creating\/updating certificates')

/**
 * ViewSet for managing certificates
 */
export const CertificatesDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Certificate.')
})

export const CertificatesDestroyResponse = zod.void()

/**
 * Get violations associated with this certificate's car
 */
export const CertificatesViolationsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this Certificate.')
})

export const certificatesViolationsRetrieveResponseJurisdictionMax = 100;

export const certificatesViolationsRetrieveResponseCustomTypeMax = 100;

export const certificatesViolationsRetrieveResponseAttachmentsItemPageNumberMin = 0;
export const certificatesViolationsRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;



export const CertificatesViolationsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesViolationsRetrieveResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "customType": zod.string().max(certificatesViolationsRetrieveResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected'),
  "car": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().nullable(),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "daysUntilExpiration": zod.number(),
  "status": zod.string(),
  "violationSummary": zod.record(zod.string(), zod.unknown()).describe('Get summary of violations for this certificate\'s car'),
  "inspectionStatus": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "downloadUrl": zod.string().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesViolationsRetrieveResponseAttachmentsItemPageNumberMin).max(certificatesViolationsRetrieveResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "inspectionDetails": zod.record(zod.string(), zod.unknown()).nullable()
}).strict().describe('Serializer for list view - includes related data needed for table display')

/**
 * Get detailed certificate statistics
 */
export const certificatesStatisticsRetrieveResponseJurisdictionMax = 100;

export const certificatesStatisticsRetrieveResponseCustomTypeMax = 100;

export const certificatesStatisticsRetrieveResponseAttachmentsItemPageNumberMin = 0;
export const certificatesStatisticsRetrieveResponseAttachmentsItemPageNumberMax = 2147483647;



export const CertificatesStatisticsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "jurisdiction": zod.string().max(certificatesStatisticsRetrieveResponseJurisdictionMax).nullish().describe('The jurisdiction that issued the certificate'),
  "customType": zod.string().max(certificatesStatisticsRetrieveResponseCustomTypeMax).nullish().describe('Custom inspection type when \'Other\' is selected'),
  "car": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict(),
  "property": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "address": zod.string().nullable(),
  "timeZone": zod.string().optional()
}).strict().nullable(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "region": zod.string().nullable(),
  "dateIssued": zod.string().date().describe('The date when the certificate was issued'),
  "expirationDate": zod.string().date().describe('The date when the certificate expires'),
  "daysUntilExpiration": zod.number(),
  "status": zod.string(),
  "violationSummary": zod.record(zod.string(), zod.unknown()).describe('Get summary of violations for this certificate\'s car'),
  "inspectionStatus": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "downloadUrl": zod.string().nullable(),
  "attachments": zod.array(zod.object({
  "id": zod.string().uuid(),
  "attachmentId": zod.string().uuid(),
  "attachmentUrl": zod.string().nullable(),
  "fileType": zod.enum(['pdf', 'image', 'spreadsheet']).describe('\* `pdf` - PDF\n\* `image` - Image\n\* `spreadsheet` - Spreadsheet'),
  "isPrimary": zod.boolean().optional(),
  "isNextPage": zod.boolean().optional(),
  "pageNumber": zod.number().min(certificatesStatisticsRetrieveResponseAttachmentsItemPageNumberMin).max(certificatesStatisticsRetrieveResponseAttachmentsItemPageNumberMax).nullish()
}).strict()),
  "inspectionDetails": zod.record(zod.string(), zod.unknown()).nullable()
}).strict().describe('Serializer for list view - includes related data needed for table display')

